import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const resizeObserverErr = window.onerror;
  window.onerror = function (err, ...args) {
    if (
      err.includes('ResizeObserver') || 
      err.includes('MutationObserver') ||
      err.includes('IntersectionObserver')
    ) {
      return false; // Suppress observer errors
    }
    return resizeObserverErr?.(err, ...args);
  };

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

